import { useTranslation } from "react-i18next";

import { getDate } from "../../date";
import { ActionKind } from "../../types/Action";
import { Button } from "../Button";
import { useRootState, RootStateKind } from "../state/StateProvider";

export const OperatorMenu = () => {
    const { t } = useTranslation();
    const {
        state: { accessibilityMode },
        dispatch
    } = useRootState(RootStateKind.Operator);

    return (
        <div data-testid="cartComponent" className="flex h-full flex-col">
            <div className="m-4 text-3xl font-bold text-primary-900">
                {t("operatorMode")}
            </div>
            <div className="flex h-full flex-col gap-3 p-3 pb-16">
                <div className="grid grid-cols-2 gap-2 px-3">
                    {[
                        {
                            label: t("order", { count: 2 }),
                            action: () => {
                                const date = getDate(new Date());
                                dispatch({
                                    kind: ActionKind.ShowOrders,
                                    dateRange: {
                                        from: date,
                                        to: date
                                    }
                                });
                            }
                        },
                        {
                            label: t("insight", { count: 2 }),
                            action: () => {
                                const date = getDate(new Date());
                                dispatch({
                                    kind: ActionKind.ShowInsights,
                                    dateRange: {
                                        from: date,
                                        to: date
                                    },
                                    groupBy: "scoId"
                                });
                            }
                        },
                        {
                            label: t("operator.hardware.title", { count: 2 }),
                            action: () =>
                                dispatch({
                                    kind: ActionKind.ShowHardware
                                })
                        },
                        {
                            label: t("operator.systemInformation.title"),
                            action: () =>
                                dispatch({
                                    kind: ActionKind.ShowSystemInformation
                                })
                        },
                        {
                            label: t("operator.configuration.title"),
                            action: () => {
                                dispatch({
                                    kind: ActionKind.ShowConfiguration
                                });
                            },
                            testId: "operator-config"
                        }
                    ].map(({ label, action, testId }) => (
                        <Button
                            key={label}
                            variant="subtle"
                            data-testid={testId}
                            className={`grid grid-rows-1 py-20 ${
                                accessibilityMode
                                    ? "grid-cols-2 gap-x-1"
                                    : "grid-cols-1"
                            } place-items-center px-4 text-center text-lg font-semibold`}
                            onClick={() => action()}
                        >
                            {t(label)}
                        </Button>
                    ))}
                </div>
            </div>
        </div>
    );
};
